interface LogoSvgProps {
  variant?: 'full' | 'symbol';
  className?: string;
}

export function LogoSvg({ variant = 'full', className }: LogoSvgProps) {
  const src = variant === 'symbol' ? '/img/logos/svg/simbolo/branco.svg' : '/img/logos/svg/branca/logo.svg';

  const alt = variant === 'symbol' ? 'Alamo - Símbolo' : 'Alamo';

  return <img src={src} alt={alt} className={className} loading="eager" decoding="async" />;
}
